import { useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, CircularProgress, Alert } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import PageService from '../../services/PageService'

const DeletePagesConfirmationModal = ({
  deleteOpen,
  setDeleteOpen,
  pagesToggler,
  setPagesToggler,
  pagesToDelete,
  setPagesToDelete,
  setCheckedPages
}) => {
  const [loading, setLoading] = useState(false)

  const handleCloseDeleteDialog = () => {
    setDeleteOpen(false)
  }

  const handleDeletePages = async () => {
    setLoading(true)
    try {
      await PageService.deletePages(pagesToDelete)
      setCheckedPages([])
      setPagesToDelete([])
      setPagesToggler(!pagesToggler)
      setDeleteOpen(false)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={deleteOpen} onClose={handleCloseDeleteDialog}>
      <Box className="deletePagesModal">
        <DialogTitle className="deletePagesModalTitle">
          Confirm Deletion
        </DialogTitle>
        <DialogContent className="deletePagesModalContent">
          <DialogContentText className="deletePagesModalContentText">
            Are you sure you want to delete page(s)? This action cannot be undone.
          </DialogContentText>
          <Alert className="deletePagesModalContentAlert" severity='warning'>
            <strong>Warning: </strong>
            Deleting a page with nested pages in the hierarchical structure of sitemap will also delete all its nested pages. Please review the pages carefully before proceeding.
          </Alert>
        </DialogContent>
        <DialogActions className="deletePagesModalActions">
          <Button className="deletePagesModalButton" onClick={handleCloseDeleteDialog} color="secondary" variant="outlined">
            Cancel
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="deletePagesModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="deletePagesModalButton" onClick={handleDeletePages} color="error" variant="contained" autoFocus>
              Delete
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default DeletePagesConfirmationModal